import React from 'react';
import FilterListIcon from '@mui/icons-material/FilterList';
import { styled } from '@mui/material';
import { Accordion, Colors, Text } from 'library';
import { StaffFilterOptions } from './StaffFilter';
import ZipSearch from './ZipSearch';
import {
    FilterDropdownSection,
    educationOptions,
    experienceOptions,
    filterAccordionSx,
} from 'parent-portal/shared/filters';

export default function PublicFilters({
    zipCode,
    updateZipCode,
    filters,
    onSearch,
}: {
    zipCode: string;
    updateZipCode: (event: React.ChangeEvent<HTMLInputElement>) => void;
    filters: StaffFilterOptions;
    onSearch: (filters: StaffFilterOptions) => void;
}) {
    function updateFilter(key: keyof StaffFilterOptions, value: string) {
        onSearch({ ...filters, [key]: value ? JSON.parse(value) : {} });
    }

    const title = (
        <TitleRow>
            <FilterListIcon style={{ color: Colors.darkNavy, fontSize: 20, marginRight: 8 }} />
            <Text bold variant="body1">
                Filters
            </Text>
        </TitleRow>
    );

    return (
        <FilterContainer>
            <ZipSearch zipCode={zipCode} updateZipCode={updateZipCode} search={onSearch} />
            <Accordion title={title} defaultExpanded sx={filterAccordionSx}>
                <FilterDropdownSection
                    label="Education"
                    value={JSON.stringify(filters.education)}
                    options={educationOptions}
                    onChange={(value) => updateFilter('education', value)}
                />
                <FilterDropdownSection
                    label="Experience"
                    value={JSON.stringify(filters.experience)}
                    options={experienceOptions}
                    onChange={(value) => updateFilter('experience', value)}
                />
            </Accordion>
        </FilterContainer>
    );
}

const FilterContainer = styled('div')({
    width: 260,
    flexShrink: 0,
    height: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
});

const TitleRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
});
